export * from './useGetPropertyNameColumn'
